// extracted by mini-css-extract-plugin
export default {"addToCartControl":"J1-z","giftCard":"K1-z","btnContainer":"L1-z","cartButton":"M1-z","disabled":"N1-z"};